import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList2 from "../../../components/item-list-2";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import {get_status} from "../../../config";
import DepartureDetailsModal from "./DetailsModal";
import DeparteeModal from "./departee-modal";
import {
    clearDeparture,
    getAllDeparturesPersonal,
    get_report,
    GET_REPORT_DEPARTURE
} from "../../../redux/departures";
import Modal from "../../../components/modal";
import LoadingSpinner from "../../../components/loading-spinner";

const SalidasPersonales = (props) => {
    //React Hooks
    const dispatch = useDispatch();

    //Reduz States
    const _get_all_departures_personal = useSelector((state) => state.departures_module._get_all_departures_personal);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_report = useSelector((state) => state.departures_module._get_report);


    const [isLoading, setIsLoading] = useState(false);

    const filter_options = [
        {name: "HOY", id: 1},
        {name: "AYER", id: 2},
        {name: "ÚLTIMOS 7 DÍAS", id: 3},
        {name: "ÚLTIMOS 30 DÍAS", id: 4},
        {name: "Rango de fechas", id: 5},
    ];

    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedRowId, setSelectedRowID] = useState("");
    const [departures, setDepartures] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);
    const [n_page, setNPage] = useState(0);
    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: "",
        date_end: "",
    });
    const [departeemodal] = useState({
        ruc: "",
        nombres: "",
        apellidos: "",
        foto: "",
    });

    useEffect(() => {
        dispatch(
            getAllDeparturesPersonal(
                token,
                1
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, dispatch]);


    useEffect(() => {
        if (_get_all_departures_personal.data.datos) {
            setDepartures(_get_all_departures_personal.data.datos);
            setNPage(_get_all_departures_personal.data.n_page);
        }
    }, [_get_all_departures_personal, count, props]);

    //function handlers
    function setOpen() {
        setOpenModal(!openModal);
    }

    const loadFunc = () => {
        if (_get_all_departures_personal.data.datos) {
            if (_get_all_departures_personal.data.datos.length > count) {
                const ordenado = _get_all_departures_personal.data.datos.sort((a, b) => {
                    return (
                        new Date(b.date + " 00:00:00") - new Date(a.date + " 00:00:00")
                    );
                });
                setDepartures([...departures, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        let salidas = [];
        let today = new Date();
        salidas = departures;

        let actual = _get_all_departures_personal.data.datos;

        if (e.target.value === "0") {
            setDepartures(actual);
        }

        //HOY
        if (e.target.value === "1") {
            // eslint-disable-next-line
            salidas = actual.filter((salida) => {
                if (salida.date) {
                    let fecha = new Date(salida.date + " 00:00:00");
                    if (
                        fecha.getDate() === today.getDate() &&
                        fecha.getMonth() === today.getMonth() &&
                        fecha.getFullYear() === today.getFullYear()
                    ) {
                        return salida;
                    }
                }
            });
            setDepartures(salidas);

            return;
        }

        //AYER
        if (e.target.value === "2") {
            let today = new Date();
            today.setDate(today.getDate() - 1);
            // eslint-disable-next-line
            salidas = actual.filter((salida) => {
                if (salida.date) {
                    let fecha = new Date(salida.date + " 00:00:00");
                    if (
                        fecha.getDate() === today.getDate() &&
                        fecha.getMonth() === today.getMonth() &&
                        fecha.getFullYear() === today.getFullYear()
                    ) {
                        return salida;
                    }
                }
            });
            setDepartures(salidas);

            return;
        }

        //ÚLTIMOS 7 DÍAS
        if (e.target.value === "3") {
            let today = new Date();

            today.setDate(today.getDate() - 7);
            // eslint-disable-next-line
            salidas = actual.filter((salida) => {
                if (salida.date) {
                    let fecha = new Date(salida.date + " 00:00:00");
                    if (
                        fecha.getTime() <= new Date().getTime() &&
                        fecha.getTime() >= today.getTime()
                    ) {
                        return salida;
                    }
                }
            });
            setDepartures(salidas);

            return;
        }

        //ÚLTIMOS 30 DÍAS
        if (e.target.value === "4") {
            let today = new Date();
            today.setDate(today.getDate() - 30);
            // eslint-disable-next-line
            salidas = actual.filter((salida) => {
                if (salida.date) {
                    let fecha = new Date(salida.date + " 00:00:00");
                    if (
                        fecha.getTime() >= today.getTime() &&
                        fecha.getTime() <= new Date().getTime()
                    ) {
                        return salida;
                    }
                }
            });
            setDepartures(salidas);

            return;
        }

        if (e.target.value === "5") {
            setRangeDate({
                date_end: "",
                date_start: "",
                visible: true,
            });
        }
    };

    const handleSearch = (e) => {
        if (e.target.value === "") {
            setDepartures(_get_all_departures_personal.data.datos);
            return;
        }
        setDepartures([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_departures_personal.data.datos.filter((element) => {
            if (element.establishment_name.match(re) != null) {
                return element;
            }
        });
        setDepartures(filtro);
    };

    const handleFilterRangeDate = (e) => {
        if (e.target.name === "date_start") {
            range_date.date_start = e.target.value;
        }
        if (e.target.name === "date_end") {
            range_date.date_end = e.target.value;
        }
        if (range_date.date_start !== "" && range_date.date_end !== "") {
            let date_start = new Date(range_date.date_start + " 00:00:00");
            let date_end = new Date(range_date.date_end + " 00:00:00");
            // eslint-disable-next-line
            let final = _get_all_departures_personal.data.datos.filter((x) => {
                if (x.date) {
                    let fecha = new Date(x.date + " 00:00:00");
                    if (
                        fecha.getTime() >= date_start.getTime() &&
                        fecha.getTime() <= date_end.getTime()
                    ) {
                        return x;
                    }
                }
            });

            setDepartures(final);
        }
    };

    const [page, setPage] = useState(1);

    function more_data() {
        let count = page + 1;
        setPage(count)
        dispatch(
            getAllDeparturesPersonal(
                token,
                count
            )
        );
    }

    function less_data() {
        let count = page - 1;
        setPage(count)
        dispatch(
            getAllDeparturesPersonal(
                token,
                count
            )
        );
    }

    const [fecha_inicial, setFechaInicial] = useState('');
    const [fecha_final, setFechaFinal] = useState('');
    const [modal, setModal] = useState(false);

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clearDeparture(GET_REPORT_DEPARTURE));
            setModal(false);
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clearDeparture(GET_REPORT_DEPARTURE));
            setModal(false);
            setIsLoading(false);
        }
    }, [_get_report, dispatch]);

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (fecha_inicial === "") {
            toast.error("Debe seleccionar la fecha inicial");
            return;
        }
        if (fecha_final === "") {
            toast.error("Debe seleccionar la fecha final");
            return;
        }
        // setReport(false);
        setModal(false);
        dispatch(get_report({'fecha_inicio': fecha_inicial, 'fecha_fin': fecha_final, 'tipo': 'personales'}, token))
    }

    return (
        <div className='app-content content'>
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className='content-wrapper'>
                <div className='content-header row'>
                    <div className='content-header-left col-12 mb-2 '>
                        <Breadcrumbs
                            title='Salidas'
                            items={[{label: "Listado permisos", link: "/salidas-personales"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className='content-body'>
                    <div className='content-area-wrapper' style={{margin: 0}}>
                        <div className={`sidebar-left ${showSibarLeft ? "show" : ""}`}>
                            <div className='sidebar'>
                                <div className='sidebar-content email-app-sidebar d-flex mb-20'>
                                    {/* sidebar close icon */}
                                    <span
                                        className='sidebar-close-icon'
                                        onClick={() => {
                                            setShowSibarLeft(false);
                                            setShowOverlay(false);
                                        }}
                                    >
                                        <i className='bx bx-x'/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className='email-app-menu'>
                                        <div className='sidebar-menu-list'>
                                            {/* sidebar menu  */}
                                            <div className='list-group list-group-messages'>
                                                <SelectInput
                                                    id='filtro-salida'
                                                    name='filtro-salida'
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className='list-unstyled mb-5'>
                                                    {range_date.visible ? (
                                                        <>
                                                            <li className=' mr-2 mb-1'>
                                                                <Input
                                                                    type='date'
                                                                    label='Fecha Inicio'
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'
                                                                />
                                                                <Input
                                                                    type='date'
                                                                    label='Fecha Fin'
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'
                                                                />
                                                            </li>
                                                            <hr/>
                                                        </>
                                                    ) : null}
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='content-right'>
                            <div className='content-overlay'/>
                            <div className='content-wrapper'>
                                <div className='content-header row'/>
                                <div className='content-body'>
                                    {/* email app overlay */}
                                    <div
                                        className={`app-content-overlay ${
                                            showOverlay ? "show" : ""
                                        }`}
                                        onClick={() => {
                                            setShowSibarRight(!showSibarRight);
                                            setShowSibarLeft(false);
                                            // setShowDetail(false);
                                            setShowOverlay(!showOverlay);
                                        }}
                                    />
                                    <div className='email-app-area'>
                                        <div className='email-app-list-wrapper'>
                                            <div className='email-app-list'>
                                                <div
                                                    className='email-action'
                                                    style={
                                                        openModal === true ? {display: "none"} : null
                                                    }
                                                >
                                                    <div
                                                        className='action-right d-flex flex-grow-1 align-items-center justify-content-around'>
                                                        <div
                                                            className='email-fixed-search flex-grow-1'
                                                            style={
                                                                openModal === true ? {display: "none"} : null
                                                            }
                                                        >
                                                            <div
                                                                className='sidebar-toggle d-block d-lg-none'
                                                                onClick={() => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }}
                                                            >
                                                                <i className='bx bx-menu'/>
                                                            </div>
                                                            {" "}
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento"}
                                                                            onChange={handleSearch}
                                                                    />
                                                                </div>
                                                                <div className="col-2">
                                                                    <Button
                                                                        text={<h3><i
                                                                            className="text-white bx bx-export"/></h3>}
                                                                        theme="success"
                                                                        type="button"
                                                                        classes="btn-lg round"
                                                                        onClick={() => {
                                                                            setModal(true);
                                                                            setFechaInicial('');
                                                                            setFechaFinal('');
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                <div className="row" style={{marginTop: 10, marginBottom: 5}}>
                                                    <div className="col-4">
                                                        <label className="ml-1">Página {page}</label>
                                                    </div>
                                                    <div className="col-8 text-right">
                                                        {(page > 1 && page <= n_page) &&
                                                            <button className="btn btn-primary mr-1" type="button"
                                                                    onClick={() => {
                                                                        less_data();
                                                                    }}><i className="bx bx-arrow-back"></i></button>
                                                        }
                                                        {(page >= 1 && page < n_page) &&
                                                            <button className="btn btn-success" type="button"
                                                                    onClick={() => {
                                                                        more_data();
                                                                    }}><i className="bx bx-right-arrow-alt"></i></button>
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className='email-user-list list-group'
                                                    style={openModal === true ? {display: "none"} : {}}
                                                >
                                                    <ul
                                                        className='users-list-wrapper media-list'
                                                        style={{
                                                            overflowY: "scroll",
                                                        }}
                                                    >
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}
                                                            loader={
                                                                <div className='col-12 d-flex justify-content-center'>
                                                                    <div
                                                                        className='spinner-border text-success'
                                                                        role='status'
                                                                    >
                                                                        <span className='sr-only'>Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {departures.map((item, index) => (
                                                                <ItemList2
                                                                    item={item}
                                                                    title={item.establishment_name}
                                                                    subtitle={item.reason_desciption}
                                                                    rightDescription={`${item.type_reason}`}
                                                                    SecondrightDescription={`Estado: ${item.state_description}`}
                                                                    bulletType={get_status(
                                                                        item.state_description
                                                                    )}
                                                                    onClick={() => {
                                                                        setSelectedRowID(item.departure_id);
                                                                        setOpenModal(true);
                                                                    }}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    <div className='no-results'>
                                                        <i className='bx bx-error-circle font-large-2'/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                                {openModal === true ? (
                                                    <DepartureDetailsModal
                                                        open={openModal}
                                                        setOpen={setOpen}
                                                        departure_id={selectedRowId}
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                        <DeparteeModal item={departeemodal}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleGenerateReport}>
                    <div className="card-body">
                        <h5 className="mb-2">Exportar datos</h5>
                        <div className="form-group">
                            <Input
                                type="date"
                                label="Fecha Inicio"
                                onChange={(e) => {
                                    setFechaInicial(e.target.value)
                                }}
                                name='fecha_inicial'
                                value={fecha_inicial}
                            />
                            <Input
                                type="date"
                                label="Fecha Fin"
                                onChange={(e) => {
                                    setFechaFinal(e.target.value)
                                }}
                                name='fecha_final'
                                value={fecha_final}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button className={`btn btn-success mb-1 button_div`} disabled={isLoading}>Exportar</button>
                        <button type="button" onClick={() => {
                            setFechaInicial('');
                            setFechaFinal('');
                            setModal(false);
                        }} className={`btn btn-outline-danger button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default SalidasPersonales;
